import { FormattedMessage } from 'react-intl';

export enum OrderStatusName {
    ANY = 'order_any_state',
    PENDING = 'order_pending',
    PROCESSING = 'order_processing',
    COMPLETED = 'order_completed',
    CANCELLED = 'order_cancelled'
}

export class OrderStatus {
    static readonly ANY = new OrderStatus(
        OrderStatusName.ANY,
        (
            <FormattedMessage
                id='OrderStatus.any'
                description='The displayed value for the OrderStatus any state'
                defaultMessage='Any state'
            />
        )
    );
    static readonly PENDING = new OrderStatus(
        OrderStatusName.PENDING,
        (
            <FormattedMessage
                id='OrderStatus.pending'
                description='The displayed value for the OrderStatus pending'
                defaultMessage='Pending'
            />
        )
    );
    static readonly PROCESSING = new OrderStatus(
        OrderStatusName.PROCESSING,
        (
            <FormattedMessage
                id='OrderStatus.processing'
                description='The displayed value for the OrderStatus processing'
                defaultMessage='Processing'
            />
        )
    );
    static readonly COMPLETED = new OrderStatus(
        OrderStatusName.COMPLETED,
        (
            <FormattedMessage
                id='OrderStatus.completed'
                description='The displayed value for the OrderStatus completed'
                defaultMessage='Completed'
            />
        )
    );
    static readonly CANCELLED = new OrderStatus(
        OrderStatusName.CANCELLED,
        (
            <FormattedMessage
                id='OrderStatus.cancelled'
                description='The displayed value for the OrderStatus cancelled state'
                defaultMessage='Cancelled'
            />
        )
    );

    static readonly ALL = [OrderStatus.ANY, OrderStatus.PENDING, OrderStatus.PROCESSING, OrderStatus.COMPLETED, OrderStatus.CANCELLED];

    constructor(
        public readonly name: OrderStatusName,
        public readonly display: React.ReactNode
    ) {}

    static getByValue(value: OrderStatusName | string): OrderStatus | undefined {
        return OrderStatus.ALL.find((status) => status.name === value);
    }

    static getType(value: OrderStatusName | string): string {
        switch (value) {
            case OrderStatusName.ANY:
                return 'bg-status-disabled';
            case OrderStatusName.PENDING:
                return 'bg-foreground-default';
            case OrderStatusName.PROCESSING:
                return 'bg-status-warning';
            case OrderStatusName.COMPLETED:
                return 'bg-status-success';
            case OrderStatusName.CANCELLED:
                return 'bg-status-danger';
            default:
                return 'bg-foreground-default';
        }
    }

    static format(value: string): string {
        return value
            .replace(/^order_/, '')
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (character) => character.toUpperCase());
    }
}
